import React from 'react';

/**
 * Page showing documents for a specific agent within the agency.
 */
export const AgentDocuments = () => {
  return (
    <div>
      <h2>Agent Documents</h2>
    </div>
  );
};
